const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-57b930da-afbf-4dcc-8942-de888844902a {\n        fill: #5e3524;\n      }\n\n      .uuid-b034403a-6a8a-489e-91ef-98b109f76f71, .uuid-77f50d3c-310e-47f5-b3db-4df41369a91e {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linejoin: round;\n      }\n\n      .uuid-77f50d3c-310e-47f5-b3db-4df41369a91e {\n        stroke-width: 2px;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-694a2dd5-be42-47de-9781-00b4ef495592",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-57b930da-afbf-4dcc-8942-de888844902a",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-1e127460-cef9-4617-9bea-f1ec788440f5",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-77f50d3c-310e-47f5-b3db-4df41369a91e",
  d: "M33.67,26.3c.5.04.94-.34.96-.85.17-3.51-.12-15.95-12.46-15.95s-12.98,12.47-12.76,15.96c.03.5.46.87.96.83l8.65-.64c1.99-.15,4-.15,5.99,0l8.66.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-77f50d3c-310e-47f5-b3db-4df41369a91e",
  d: "M33.28,26.27v6.38c0,.95-.86,1.68-1.85,1.58l-5.45-1.29c-.41-.1-.83-.17-1.24-.21-1.79-.15-3.6-.15-5.4,0-.42.04-.83.11-1.23.2l-5.51,1.29c-.98.1-1.84-.63-1.84-1.58v-6.38"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-b034403a-6a8a-489e-91ef-98b109f76f71",
  d: "M31.17,26.11v4c0,.71-.7,1.27-1.5,1.19,0,0-5.1-1.1-5.44-1.13-1.46-.12-2.93-.12-4.39,0-.34.03-5.48,1.13-5.48,1.13-.8.08-1.5-.48-1.5-1.19v-4"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-b034403a-6a8a-489e-91ef-98b109f76f71",
  d: "M20.59,9.57s-6.09,3.29-6.32,16.44"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-b034403a-6a8a-489e-91ef-98b109f76f71",
  d: "M23.53,9.56s5.97,3.3,6.21,16.45"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "uuid-b034403a-6a8a-489e-91ef-98b109f76f71",
  cx: 22.05,
  cy: 20.1,
  rx: 3.47,
  ry: 2.21
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "uuid-b034403a-6a8a-489e-91ef-98b109f76f71",
  cx: 22.05,
  cy: 9.11,
  rx: 1.17,
  ry: 0.75
}));
function SvgRepozeIconCategoryAccessories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryAccessories);
export default __webpack_public_path__ + "static/media/repoze_icon_category-accessories.e5d230fee9f837460d7a6e3ca98a3028.svg";
export { ForwardRef as ReactComponent };